import { API, Auth } from "aws-amplify";

import { isValidUUID } from "../../utils/helpers";

//NOTE: This API assumes that the validity of objects has been checked
//by the calling code (in this case the omniDataAPI). If we had a full
//dev team we would add full validation in that layer above. For now
//we're going to just get it right and skip heavy object validation routines.

//This is the name of the resource configured using AWS IDs

const gatewayId = "OmniAPI";
const defaultRetries = 0;

//#region Administrators
export const awsCreateAdministrator = async (administratorODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "administrators/";
  if (isValidUUID(administratorODM._id)) {
    apiPath = `administrators/${administratorODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },

    body: {
      ...administratorODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateAdministrator Retry: " + (defaultRetries + 1 - retries));
        return awsCreateAdministrator(administratorODM, --retries);
      }
    });
};

export const awsUpdateAdministrator = async (administratorODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `administrators/${administratorODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...administratorODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdateAdministrator Retry: " + (defaultRetries + 1 - retries));
        return awsUpdateAdministrator(administratorODM, --retries);
      }
    });
};

export const awsDeleteAdministrator = async (administratorId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `administrators/${administratorId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return administratorId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeleteAdministrator Retry: " + (defaultRetries + 1 - retries));
        return awsDeleteAdministrator(administratorId, --retries);
      }
    });
};

export const awsGetAdministrator = async (administratorId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `administrators/${administratorId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetAdministrator Retry: " + (defaultRetries + 1 - retries));
        return awsGetAdministrator(administratorId, --retries);
      }
    });
};

export const awsGetAdministrators = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `administrators/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetAdministrators Retry: " + (defaultRetries + 1 - retries));
        return awsGetAdministrators(page, pageSize, includeInactive, --retries);
      }
    });
};
//#endregion

//#region Assessment
export const awsCreateAssessment = async (assessmentODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "assessments/";
  if (isValidUUID(assessmentODM._id)) {
    apiPath = `assessments/${assessmentODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...assessmentODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateAssessment Retry: " + (defaultRetries + 1 - retries));
        return awsCreateAssessment(assessmentODM, --retries);
      }
    });
};

export const awsUpdateAssessment = async (assessmentODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `assessments/${assessmentODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...assessmentODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdateAssessment Retry: " + (defaultRetries + 1 - retries));
        return awsUpdateAssessment(assessmentODM, --retries);
      }
    });
};

export const awsDeleteAssessment = async (assessmentId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `assessments/${assessmentId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return assessmentId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeleteAssessment Retry: " + (defaultRetries + 1 - retries));
        return awsDeleteAssessment(assessmentId, --retries);
      }
    });
};

export const awsGetAssessment = async (assessmentId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `assessments/${assessmentId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetAssessment Retry: " + (defaultRetries + 1 - retries));
        return awsGetAssessment(assessmentId, --retries);
      }
    });
};

export const awsGetAssessments = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `assessments/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetAssessments Retry: " + (defaultRetries + 1 - retries));
        return awsGetAssessments(page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsGetAssessmentsBy = async (
  related_id,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  related_id = related_id ? `&related_id=${related_id}` : "";

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `assessments/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}${related_id}`;
  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetAssessmentsBy Retry: " + (defaultRetries + 1 - retries));
        return awsGetAssessmentsBy(related_id, page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsSearchAssessments = async (
  assessmentQueryODM,
  assessmentSortODM,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `assessments/search`;

  return API.post(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      includeInactive: false,
      page: page,
      pageSize: pageSize,
      query: assessmentQueryODM,
      sorting: assessmentSortODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsSearchAssessments Retry: " + (defaultRetries + 1 - retries));
        return awsSearchAssessments(
          assessmentQueryODM,
          assessmentSortODM,
          page,
          pageSize,
          includeInactive,
          --retries,
        );
      }
    });
};

//#endregion

//#region ConversationConfiguration
export const awsCreateConversationConfiguration = async (
  conversationConfigurationODM,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "conversationConfigurations/";
  if (isValidUUID(conversationConfigurationODM._id)) {
    apiPath = `conversationConfigurations/${conversationConfigurationODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...conversationConfigurationODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateConversationConfiguration Retry: " + (defaultRetries + 1 - retries));
        return awsCreateConversationConfiguration(conversationConfigurationODM, --retries);
      }
    });
};

export const awsUpdateConversationConfiguration = async (
  conversationConfigurationODM,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `conversationConfigurations/${conversationConfigurationODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...conversationConfigurationODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdateConversationConfiguration Retry: " + (defaultRetries + 1 - retries));
        return awsUpdateConversationConfiguration(conversationConfigurationODM, --retries);
      }
    });
};

export const awsDeleteConversationConfiguration = async (
  conversationConfigurationId,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(
    gatewayId,
    `conversationConfigurations/${conversationConfigurationId}/omniAudit`,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
      body: {
        isActive: false,
      },
    },
  )
    .then(response => {
      return conversationConfigurationId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeleteConversationConfiguration Retry: " + (defaultRetries + 1 - retries));
        return awsDeleteConversationConfiguration(conversationConfigurationId, --retries);
      }
    });
};

export const awsGetConversationConfiguration = async (
  conversationConfigurationId,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `conversationConfigurations/${conversationConfigurationId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetConversationConfiguration Retry: " + (defaultRetries + 1 - retries));
        return awsGetConversationConfiguration(conversationConfigurationId, --retries);
      }
    });
};

export const awsGetConversationConfigurations = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `conversationConfigurations/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetConversationConfigurations Retry: " + (defaultRetries + 1 - retries));
        return awsGetConversationConfigurations(page, pageSize, includeInactive, --retries);
      }
    });
};
//#endregion

//#region Invite
export const awsCreateInvite = async (inviteODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "invites/";
  if (isValidUUID(inviteODM._id)) {
    apiPath = `invites/${inviteODM._id}`;
  }

  var now = new Date();
  inviteODM.omniData.sentDatetime = now.toISOString();
  // inviteODM.omniData.filledDatetime = now.toISOString();

  now.setDate(now.getDate() + 3650); //10 years

  inviteODM.omniData.expiresAt = now.toISOString();
  inviteODM.omniData.invitationStatus = "created";
  inviteODM.omniData.extraFields = {};
  inviteODM.omniData.invitationEvents = [];

  // omniData: inviteODM.omniData,
  // omniRelationships: inviteODM.omniRelationships,

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...inviteODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateInvite Retry: " + (defaultRetries + 1 - retries));
        return awsCreateInvite(inviteODM, --retries);
      }
    });
};

export const awsUpdateInvite = async (inviteODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `invites/${inviteODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...inviteODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdateInvite Retry: " + (defaultRetries + 1 - retries));
        return awsUpdateInvite(inviteODM, --retries);
      }
    });
};

export const awsDeleteInvite = async (inviteId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `invites/${inviteId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return inviteId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeleteInvite Retry: " + (defaultRetries + 1 - retries));
        return awsDeleteInvite(inviteId, --retries);
      }
    });
};

export const awsGetInvite = async (inviteId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `invites/${inviteId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetInvite Retry: " + (defaultRetries + 1 - retries));
        return awsGetInvite(inviteId, --retries);
      }
    });
};

export const awsGetInvites = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `invites/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetInvites Retry: " + (defaultRetries + 1 - retries));
        return awsGetInvites(page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsGetInvitesBy = async (
  relatedId,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  relatedId = relatedId ? `&related_id=${relatedId}` : "";

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `invites/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}${relatedId}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetInvitesBy Retry: " + (defaultRetries + 1 - retries));
        return awsGetInvitesBy(relatedId, page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsCreateBulkInvites = async (inviteODMs, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "invites/bulk";

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      items: inviteODMs,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateInvite Retry: " + (defaultRetries + 1 - retries));
        return awsCreateBulkInvites(inviteODMs, --retries);
      }
    });
};

export const awsDeleteBulkInvites = async (inviteQueryODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "invites/bulk/omniData";

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
      filters: {
        includeInactive: false,
        relatedId: "",
        query: inviteQueryODM,
      },
      action: "run",
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateInvite Retry: " + (defaultRetries + 1 - retries));
        return awsCreateBulkInvites(inviteQueryODM, --retries);
      }
    });
};
//#endregion

//#region Motivation
export const awsCreateMotivation = async (motivationODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "motivations/";
  if (isValidUUID(motivationODM._id)) {
    apiPath = `motivations/${motivationODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...motivationODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateMotivation Retry: " + (defaultRetries + 1 - retries));
        return awsCreateMotivation(motivationODM, --retries);
      }
    });
};

export const awsUpdateMotivation = async (motivationODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `motivations/${motivationODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...motivationODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdateMotivation Retry: " + (defaultRetries + 1 - retries));
        return awsUpdateMotivation(motivationODM, --retries);
      }
    });
};

export const awsDeleteMotivation = async (motivationId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `motivations/${motivationId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return motivationId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeleteMotivation Retry: " + (defaultRetries + 1 - retries));
        return awsDeleteMotivation(motivationId, --retries);
      }
    });
};

export const awsGetMotivation = async (motivationId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `motivations/${motivationId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetMotivation Retry: " + (defaultRetries + 1 - retries));
        return awsGetMotivation(motivationId, --retries);
      }
    });
};

export const awsGetMotivations = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `motivations/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetMotivations Retry: " + (defaultRetries + 1 - retries));
        return awsGetMotivations(page, pageSize, includeInactive, --retries);
      }
    });
};
//#endregion

//#region Onboarding
export const awsOnboardPatient = async (patientODM, inviteKey, retries = defaultRetries) => {
  //NO AUTH!

  let apiPath = `onboarding/patients/${inviteKey}`;
  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    // headers: {
    //   authorization: `Bearer ${token}`,
    // },
    body: {
      ...patientODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateOnboarding Retry: " + (defaultRetries + 1 - retries));
        return awsOnboardPatient(patientODM, inviteKey, --retries);
      }
    });
};

export const awsOnboardPartner = async (partnerODM, inviteKey, retries = defaultRetries) => {
  //NO AUTH!

  let apiPath = `onboarding/partners/${inviteKey}`;
  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    // headers: {
    //   authorization: `Bearer ${token}`,
    // },
    body: {
      ...partnerODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateOnboarding Retry: " + (defaultRetries + 1 - retries));
        return awsOnboardPartner(partnerODM, inviteKey, --retries);
      }
    });
};

export const awsOnboardProvider = async (providerODM, inviteKey, retries = defaultRetries) => {
  //NO AUTH!

  let apiPath = `onboarding/providers/${inviteKey}`;
  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    // headers: {
    //   authorization: `Bearer ${token}`,
    // },
    body: {
      ...providerODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateOnboarding Retry: " + (defaultRetries + 1 - retries));
        return awsOnboardProvider(providerODM, inviteKey, --retries);
      }
    });
};

export const awsOnboardAdministrator = async (
  administratorODM,
  inviteKey,
  retries = defaultRetries,
) => {
  //NO AUTH!

  let apiPath = `onboarding/administrators/${inviteKey}`;
  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    // headers: {
    //   authorization: `Bearer ${token}`,
    // },
    body: {
      ...administratorODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateOnboarding Retry: " + (defaultRetries + 1 - retries));
        return awsOnboardAdministrator(administratorODM, inviteKey, --retries);
      }
    });
};

export const awsGetOnboarding = async (onboardingId, retries = defaultRetries) => {
  //NO AUTH!

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `onboarding/${onboardingId}`, {})
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetOnboarding Retry: " + (defaultRetries + 1 - retries));
        return awsGetOnboarding(onboardingId, --retries);
      }
    });
};

export const awsUnsubscribeUser = async (inviteKey, retries = defaultRetries) => {
  //NO AUTH!

  let apiPath = `onboarding/${inviteKey}/unsubscribe`;
  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, apiPath, {})
    .then(response => {
      return "success";
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUnsubscribeUser Retry: " + (defaultRetries + 1 - retries));
        return awsUnsubscribeUser(inviteKey, --retries);
      }
    });
};

//#endregion

//#region Organization

export const awsCreateOrganization = async (organizationODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "organizations/";
  if (isValidUUID(organizationODM._id)) {
    apiPath = `organizations/${organizationODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...organizationODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateOrganization Retry: " + (defaultRetries + 1 - retries));
        return awsCreateOrganization(organizationODM, --retries);
      }
    });
};

export const awsUpdateOrganization = async (organizationODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `organizations/${organizationODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...organizationODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdateOrganization Retry: " + (defaultRetries + 1 - retries));
        return awsUpdateOrganization(organizationODM, --retries);
      }
    });
};

export const awsDeleteOrganization = async (organizationId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `organizations/${organizationId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return organizationId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeleteOrganization Retry: " + (defaultRetries + 1 - retries));
        return awsDeleteOrganization(organizationId, --retries);
      }
    });
};

export const awsGetOrganization = async (organizationId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `organizations/${organizationId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetOrganization Retry: " + (defaultRetries + 1 - retries));
        return awsGetOrganization(organizationId, --retries);
      }
    });
};

export const awsGetOrganizations = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(
    gatewayId,
    `organizations/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    },
  )
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetOrganizations Retry: " + (defaultRetries + 1 - retries));
        return awsGetOrganizations(page, pageSize, includeInactive, --retries);
      }
    });
};
//#endregion

//#region Partner
export const awsCreatePartner = async (partnerODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "partners/";
  if (isValidUUID(partnerODM._id)) {
    apiPath = `partners/${partnerODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...partnerODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreatePartner Retry: " + (defaultRetries + 1 - retries));
        return awsCreatePartner(partnerODM, --retries);
      }
    });
};

export const awsUpdatePartner = async (partnerODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `partners/${partnerODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...partnerODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdatePartner Retry: " + (defaultRetries + 1 - retries));
        return awsUpdatePartner(partnerODM, --retries);
      }
    });
};

export const awsDeletePartner = async (partnerId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `partners/${partnerId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return partnerId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeletePartner Retry: " + (defaultRetries + 1 - retries));
        return awsDeletePartner(partnerId, --retries);
      }
    });
};

export const awsGetPartner = async (partnerId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `partners/${partnerId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetPartner Retry: " + (defaultRetries + 1 - retries));
        return awsGetPartner(partnerId, --retries);
      }
    });
};

export const awsGetPartners = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();

  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `partners/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetPartners Retry: " + (defaultRetries + 1 - retries));
        return awsGetPartners(page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsSearchPartners = async (
  partnerQueryODM,
  partnerSortODM,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `partners/search`;

  return API.post(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      includeInactive: false,
      page: page,
      pageSize: pageSize,
      query: partnerQueryODM,
      sorting: partnerSortODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsSearchPartners Retry: " + (defaultRetries + 1 - retries));
        return awsSearchPartners(
          partnerQueryODM,
          partnerSortODM,
          page,
          pageSize,
          includeInactive,
          --retries,
        );
      }
    });
};

//#endregion

//#region Patients
export const awsCreatePatient = async (patientODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "patients/";
  if (isValidUUID(patientODM._id)) {
    apiPath = `patients/${patientODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...patientODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreatePatient Retry: " + (defaultRetries + 1 - retries));
        return awsCreatePatient(patientODM, --retries);
      }
    });
};

export const awsUpdatePatient = async (patientODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `patients/${patientODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...patientODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdatePatient Retry: " + (defaultRetries + 1 - retries));
        return awsUpdatePatient(patientODM, --retries);
      }
    });
};

export const awsDeletePatient = async (patientId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `patients/${patientId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return patientId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeletePatient Retry: " + (defaultRetries + 1 - retries));
        return awsDeletePatient(patientId, --retries);
      }
    });
};

export const awsGetPatient = async (patientId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `patients/${patientId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetPatient Retry: " + (defaultRetries + 1 - retries));
        return awsGetPatient(patientId, --retries);
      }
    });
};

export const awsGetPatients = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `patients/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetPatients Retry: " + (defaultRetries + 1 - retries));
        return awsGetPatients(page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsGetPatientsBy = async (
  relatedId,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  relatedId = relatedId ? `&related_id=${relatedId}` : "";

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `patients/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}${relatedId}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetPatientsBy Retry: " + (defaultRetries + 1 - retries));
        return awsGetPatientsBy(relatedId, page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsSearchPatients = async (
  patientQueryODM,
  patientSortODM,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `patients/search`;

  return API.post(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      includeInactive: false,
      page: page,
      pageSize: pageSize,
      query: patientQueryODM,
      sorting: patientSortODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsSearchPatients Retry: " + (defaultRetries + 1 - retries));
        return awsSearchPatients(
          patientQueryODM,
          patientSortODM,
          page,
          pageSize,
          includeInactive,
          --retries,
        );
      }
    });
};

export const awsSearchInvites = async (
  inviteQueryODM,
  inviteSortODM,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `invites/search`;

  return API.post(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      includeInactive: false,
      page: page,
      pageSize: pageSize,
      query: inviteQueryODM,
      sorting: inviteSortODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsSearchInvites Retry: " + (defaultRetries + 1 - retries));
        return awsSearchInvites(
          inviteQueryODM,
          inviteSortODM,
          page,
          pageSize,
          includeInactive,
          --retries,
        );
      }
    });
};

//#endregion

//#region Practice

export const awsCreatePractice = async (practiceODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "practices/";
  if (isValidUUID(practiceODM._id)) {
    apiPath = `practices/${practiceODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...practiceODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreatePractice Retry: " + (defaultRetries + 1 - retries));
        return awsCreatePractice(practiceODM, --retries);
      }
    });
};

export const awsUpdatePractice = async (practiceODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `practices/${practiceODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...practiceODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdatePractice Retry: " + (defaultRetries + 1 - retries));
        return awsUpdatePractice(practiceODM, --retries);
      }
    });
};

export const awsDeletePractice = async (practiceId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `practices/${practiceId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return practiceId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeletePractice Retry: " + (defaultRetries + 1 - retries));
        return awsDeletePractice(practiceId, --retries);
      }
    });
};

export const awsGetPractice = async (practiceId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `practices/${practiceId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetPractice Retry: " + (defaultRetries + 1 - retries));
        return awsGetPractice(practiceId, --retries);
      }
    });
};

export const awsGetPractices = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(
    gatewayId,
    `practices/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`,
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    },
  )
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetPractices Retry: " + (defaultRetries + 1 - retries));
        return awsGetPractices(page, pageSize, includeInactive, --retries);
      }
    });
};
//#endregion

//#region Provider
export const awsCreateProvider = async (providerODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "providers/";
  if (isValidUUID(providerODM._id)) {
    apiPath = `providers/${providerODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...providerODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateProvider Retry: " + (defaultRetries + 1 - retries));
        return awsCreateProvider(providerODM, --retries);
      }
    });
};

export const awsUpdateProvider = async (providerODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `providers/${providerODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...providerODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdateProvider Retry: " + (defaultRetries + 1 - retries));
        return awsUpdateProvider(providerODM, --retries);
      }
    });
};

export const awsDeleteProvider = async (providerId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `providers/${providerId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return providerId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeleteProvider Retry: " + (defaultRetries + 1 - retries));
        return awsDeleteProvider(providerId, --retries);
      }
    });
};

export const awsGetProvider = async (providerId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `providers/${providerId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetProvider Retry: " + (defaultRetries + 1 - retries));
        return awsGetProvider(providerId, --retries);
      }
    });
};

export const awsGetProviders = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `providers/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetProviders Retry: " + (defaultRetries + 1 - retries));
        return awsGetProviders(page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsSearchProviders = async (
  providerQueryODM,
  providerSortODM,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `providers/search`;

  return API.post(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      includeInactive: false,
      page: page,
      pageSize: pageSize,
      query: providerQueryODM,
      sorting: providerSortODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsSearchProviders Retry: " + (defaultRetries + 1 - retries));
        return awsSearchProviders(
          providerQueryODM,
          providerSortODM,
          page,
          pageSize,
          includeInactive,
          --retries,
        );
      }
    });
};

//#endregion

//#region Exports

export const awsExportAssessedPatients = async (
  assessmentType,
  onlyFields = null,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  onlyFields = onlyFields ? `&only_fields=${onlyFields}` : "";

  //exclude is an option here

  // //API Call here maps to a Route from the aws API Gateway
  // let apiURI = `patients/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}${relatedId}`;

  let apiURI = `omni/export/patients?assessment_type=${assessmentType}${onlyFields}&include_inactive=${includeInactive}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
      accept: "text/csv",
    },
    responseType: "blob",
    response: true,
  })
    .then(response => {
      const blob = new Blob([response.data], { type: "text/csv" });
      return blob;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsExportAssessedPatients Retry: " + (defaultRetries + 1 - retries));
        return awsExportAssessedPatients(assessmentType, includeInactive, --retries);
      }
    });
};

//#endregion

//#region Reports

export const awsCreateReport = async (reportODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "reports/";

  let bodyEmAllDay = {
    typeOf: reportODM.omniData.reportType,
    name: reportODM.omniData.name,
    includeInactive: false,
    onlyFields: reportODM.omniData.onlyFields,
    assessmentTypes: [],
  };

  if (reportODM.omniData.hasOwnProperty("includeInactive")) {
    bodyEmAllDay.includeInactive = reportODM.omniData.includeInactive;
  }

  if (reportODM.omniData.hasOwnProperty("query")) {
    bodyEmAllDay["includeIds"] = reportODM.omniData.includeIds;
  }

  if (reportODM.omniData.hasOwnProperty("includeIds")) {
    bodyEmAllDay["includeIds"] = reportODM.omniData.includeIds;
  }

  if (reportODM.omniData.hasOwnProperty("questions")) {
    bodyEmAllDay["questions"] = reportODM.omniData.questions;
  }
  if (reportODM.omniData.hasOwnProperty("userType") && reportODM.omniData.userType) {
    bodyEmAllDay["userType"] = reportODM.omniData.userType;
  }

  if (reportODM.omniData.hasOwnProperty("query") && reportODM.omniData.query != null) {
    bodyEmAllDay["query"] = reportODM.omniData.query;
  }

  if (reportODM.omniData.hasOwnProperty("userType")) {
    bodyEmAllDay["user_type"] = reportODM.omniData.userType;
  }

  if (
    reportODM.omniData.hasOwnProperty("assessmentTypes") &&
    reportODM.omniData.assessmentTypes != null
  ) {
    bodyEmAllDay["assessmentTypes"] = reportODM.omniData.assessmentTypes;
  }

  // if (reportODM.omniData.hasOwnProperty("dateBefore")) {
  //   bodyEmAllDay["dateBefore"] = reportODM.omniData.dateBefore;
  // }

  // if (reportODM.omniData.hasOwnProperty("dateAfter")) {
  //   bodyEmAllDay["dateAfter"] = reportODM.omniData.dateAfter;
  // }

  // let bodyEmAllDay = {
  //   typeOf: reportODM.omniData.reportType,
  //   name: reportODM.omniData.name,
  //   includeInactive: false,
  //   // dateBefore: "2023-05-23T21:19:25.538Z",
  //   // dateAfter: "2023-05-23T21:19:25.538Z",
  //   // onlyFields: ["string"],
  //   // excludeFields: ["string"],
  //   // relatedAssessmentTypes: ["string"],
  //   // includeIds: ["string"],
  //   // excludeIds: ["string"],
  // };

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      report: {
        ...bodyEmAllDay,
      },
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateReport Retry: " + (defaultRetries + 1 - retries));
        return awsCreateReport(reportODM, --retries);
      }
    });
};

export const awsReportAssessedPatients = async (
  assessmentType,
  onlyFields = null,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  onlyFields = onlyFields ? `&only_fields=${onlyFields}` : "";

  //exclude is an option here

  // //API Call here maps to a Route from the aws API Gateway
  // let apiURI = `patients/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}${relatedId}`;

  let apiURI = `report/patients?assessment_type=${assessmentType}${onlyFields}&include_inactive=${includeInactive}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
      accept: "text/csv",
    },
    responseType: "blob",
    response: true,
  })
    .then(response => {
      const blob = new Blob([response.data], { type: "text/csv" });
      return blob;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsReportAssessedPatients Retry: " + (defaultRetries + 1 - retries));
        return awsReportAssessedPatients(assessmentType, includeInactive, --retries);
      }
    });
};

export const awsDeleteReport = async (reportId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `reports/${reportId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return reportId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeleteReport Retry: " + (defaultRetries + 1 - retries));
        return awsDeleteReport(reportId, --retries);
      }
    });
};

export const awsGetReport = async (reportId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `reports/${reportId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetReport Retry: " + (defaultRetries + 1 - retries));
        return awsGetReport(reportId, --retries);
      }
    });
};

export const awsGetReports = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `reports/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetReports Retry: " + (defaultRetries + 1 - retries));
        return awsGetReports(page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsSearchReports = async (
  reportQueryODM,
  patientSortODM,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `reports/search`;

  return API.post(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      includeInactive: false,
      page: page,
      pageSize: pageSize,
      query: reportQueryODM,
      sorting: patientSortODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsSearchReports Retry: " + (defaultRetries + 1 - retries));
        return awsSearchReports(
          reportQueryODM,
          patientSortODM,
          page,
          pageSize,
          includeInactive,
          --retries,
        );
      }
    });
};

//#endregion

//#region CommunicationRequest
export const awsCreateCommunicationRequest = async (partnerODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "communicationRequest/";
  if (isValidUUID(partnerODM._id)) {
    apiPath = `communicationRequest/${partnerODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...partnerODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateCommunicationRequest Retry: " + (defaultRetries + 1 - retries));
        return awsCreateCommunicationRequest(partnerODM, --retries);
      }
    });
};

export const awsUpdateCommunicationRequest = async (partnerODM, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `communicationRequest/${partnerODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...partnerODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdateCommunicationRequest Retry: " + (defaultRetries + 1 - retries));
        return awsUpdateCommunicationRequest(partnerODM, --retries);
      }
    });
};

export const awsDeleteCommunicationRequest = async (partnerId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `communicationRequest/${partnerId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return partnerId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeleteCommunicationRequest Retry: " + (defaultRetries + 1 - retries));
        return awsDeleteCommunicationRequest(partnerId, --retries);
      }
    });
};

export const awsGetCommunicationRequest = async (partnerId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `communicationRequest/${partnerId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetCommunicationRequest Retry: " + (defaultRetries + 1 - retries));
        return awsGetCommunicationRequest(partnerId, --retries);
      }
    });
};

export const awsGetCommunicationRequests = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();

  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `communicationRequest/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetCommunicationRequests Retry: " + (defaultRetries + 1 - retries));
        return awsGetCommunicationRequests(page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsSearchCommunicationRequests = async (
  communicationRequestQueryODM,
  communicationRequestSortODM,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `communicationRequest/search`;

  return API.post(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      includeInactive: false,
      page: page,
      pageSize: pageSize,
      query: communicationRequestQueryODM,
      sorting: communicationRequestSortODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsSearchCommunicationRequests Retry: " + (defaultRetries + 1 - retries));
        return awsSearchCommunicationRequests(
          communicationRequestQueryODM,
          communicationRequestSortODM,
          page,
          pageSize,
          includeInactive,
          --retries,
        );
      }
    });
};

//#endregion

//#region CommunicationTemplate
export const awsCreateCommunicationTemplate = async (
  communicationTemplateODM,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "communicationTemplate/";
  if (isValidUUID(communicationTemplateODM._id)) {
    apiPath = `communicationTemplate/${communicationTemplateODM._id}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...communicationTemplateODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsCreateCommunicationTemplate Retry: " + (defaultRetries + 1 - retries));
        return awsCreateCommunicationTemplate(communicationTemplateODM, --retries);
      }
    });
};

export const awsUpdateCommunicationTemplate = async (
  communicationTemplateODM,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.put(gatewayId, `communicationTemplate/${communicationTemplateODM._id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...communicationTemplateODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsUpdateCommunicationTemplate Retry: " + (defaultRetries + 1 - retries));
        return awsUpdateCommunicationTemplate(communicationTemplateODM, --retries);
      }
    });
};

export const awsDeleteCommunicationTemplate = async (partnerId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.patch(gatewayId, `communicationTemplate/${partnerId}/omniAudit`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      isActive: false,
    },
  })
    .then(response => {
      return partnerId;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsDeleteCommunicationTemplate Retry: " + (defaultRetries + 1 - retries));
        return awsDeleteCommunicationTemplate(partnerId, --retries);
      }
    });
};

export const awsGetCommunicationTemplate = async (partnerId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `communicationTemplate/${partnerId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetCommunicationTemplate Retry: " + (defaultRetries + 1 - retries));
        return awsGetCommunicationTemplate(partnerId, --retries);
      }
    });
};

export const awsGetCommunicationTemplates = async (
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();

  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `communicationTemplate/?include_inactive=${includeInactive}&page=${page}&page_size=${pageSize}`;

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetCommunicationTemplates Retry: " + (defaultRetries + 1 - retries));
        return awsGetCommunicationTemplates(page, pageSize, includeInactive, --retries);
      }
    });
};

export const awsSearchCommunicationTemplates = async (
  partnerQueryODM,
  page,
  pageSize,
  includeInactive = false,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `communicationTemplate/search`;

  return API.post(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      includeInactive: false,
      page: page,
      pageSize: pageSize,
      query: partnerQueryODM,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsSearchCommunicationTemplates Retry: " + (defaultRetries + 1 - retries));
        return awsSearchCommunicationTemplates(page, pageSize, includeInactive, --retries);
      }
    });
};

//#endregion

//#region Campaign
export const awsProsecuteCampaign = async (communicationTemplateId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  let apiPath = "campaign/";
  if (isValidUUID(communicationTemplateId)) {
    apiPath = `campaign/${communicationTemplateId}`;
  }

  //API Call here maps to a Route from the aws API Gateway
  return API.post(gatewayId, apiPath, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      ...communicationTemplateId,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsProsecuteCampaign Retry: " + (defaultRetries + 1 - retries));
        return awsProsecuteCampaign(communicationTemplateId, --retries);
      }
    });
};

export const awsGetCampaign = async (campaignId, retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  return API.get(gatewayId, `campaign/${campaignId}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsGetCampaign Retry: " + (defaultRetries + 1 - retries));
        return awsGetCampaign(campaignId, --retries);
      }
    });
};

//#endregion

export const awsHealthCheck = async (retries = defaultRetries) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `health-check`;

  return API.get(gatewayId, apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsHealthCheck Retry: " + (defaultRetries + 1 - retries));
        return awsHealthCheck(--retries);
      }
    });
};

export const awsSendEmailCommunication = async (
  communicationRequestODM,
  retries = defaultRetries,
) => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();

  //API Call here maps to a Route from the aws API Gateway
  let apiURI = `send-email`;

  // https://63f8n8uvrl.execute-api.us-west-2.amazonaws.com/send-email
  // body: {
  //   'destinations': {
  //     'to': {
  //         'partnerIds': [],
  //         'partnerQuery': {}, # Query object for the /communicationRequest/search endpoint
  //         'inviteIds': [],
  //         'inviteQuery': {} # Query object from /invites/search
  //     }
  // },
  // 'emailTemplates': [
  //     # List of objects
  //     {
  //         'organizationId': '',
  //         'emailTemplateId': ''
  //     }

  // ]
  // },;

  let theEmailTemplates = [
    {
      organizationId: "",
      emailTemplateId: communicationRequestODM.omniData.communicationTemplateId,
    },
  ];

  return API.post("OmniSES", apiURI, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    body: {
      destinations: communicationRequestODM.omniData.destinations,
      emailTemplates: theEmailTemplates,
    },
  })
    .then(response => {
      return response;
    })
    .catch(err => {
      if (retries === 0) {
        return Promise.reject(err);
      } else {
        //Recursive RETRY implementation
        console.log("awsHealthCheck Retry: " + (defaultRetries + 1 - retries));
        return awsHealthCheck(communicationRequestODM, --retries);
      }
    });
};
